import {call, put, select} from "redux-saga/effects";
import {
  setLoading, setMetaResult,
  setResult
} from "../../slices/dynamicMultipleElementsSlice";
import {getFocusedItem} from "../requests/focusedItemsService";
import {getBrandDayInfo, getBrandMonthList} from "../requests/brandService";
import { getPredictionCampaignInfo } from "../requests/predictionService";

export const alreadyDeletedMessage = "This item has been already deleted. This wont be shown in the app. Please remove it to improve the performance and SEO.";

export function* handleGetFocusedItem(action) {
  const element = 'focused';
  try {
    yield put(setLoading({element, loading: true, id: action.payload}));
    const {data} = yield call(() => getFocusedItem(action.payload));
    yield put(setResult({data, element, id: action.payload}));
  } catch (error) {
    const errMsg = !error.response ? error.message : error.response.status === 404 ? alreadyDeletedMessage : error.response.data.message;
    yield put(setResult({error: errMsg, element, id: action.payload}));
  }
}

export function* handleGetBrandDayInfo(action) {
  const element = 'brandDay';
  try {
    yield put(setLoading({element, loading: true, id: action.payload}));
    const {data: response} = yield call(() => getBrandDayInfo(action.payload));
    yield put(setResult({data: response.data, element, id: action.payload}));
  } catch (error) {
    const errMsg = !error.response ? error.message : error.response.status === 404 ? alreadyDeletedMessage : error.response.data.message;
    yield put(setResult({error: errMsg, element, id: action.payload}));
  }
}

export function* handleGetBrandMonthList(action) {
  const element = 'brandMonth';
  try {
    yield put(setLoading({element, loading: true, id: action.payload}));
    const state = yield select((state) => state.dynamicMultipleElements[element][action.payload]);
    if (!state.meta.id) {
      const {data: response} = yield call(() => getBrandDayInfo(action.payload));
      yield put(setMetaResult({data: response.data, element, id: action.payload}));
    }

    const {data: {page, has_next: hasNext, total_results: totalResults, data}}
      = yield call(() => getBrandMonthList(state.page + 1, action.payload));
    yield put(setResult({data, element, hasNext, page, totalResults, id: action.payload}));

  } catch (error) {
    const errMsg = !error.response ? error.message : error.response.status === 404 ? alreadyDeletedMessage : error.response.data.message;
    yield put(setResult({error: errMsg, element, id: action.payload}));
  }
}

export function* handleGetPredictionCampaign(action) {
  const element = 'prediction';
  try {
    yield put(setLoading({element, loading: true, id: action.payload}));
    const {data: {data}}
      = yield call(() => getPredictionCampaignInfo(action.payload));
    yield put(setResult({data, element, id: action.payload}));

  } catch (error) {
    const errMsg = !error.response ? error.message : error.response.status === 404 ? alreadyDeletedMessage : error.response.data.message;
    yield put(setResult({error: errMsg, element, id: action.payload}));
  }
}


